export const DollarSignIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="stroke-fg-1"
      {...props}>
      <path
        d="M6.375 11C6.375 11.9665 7.1585 12.75 8.125 12.75H9.75C10.7855 12.75 11.625 11.9105 11.625 10.875C11.625 9.83947 10.7855 9 9.75 9H8.25C7.21447 9 6.375 8.16053 6.375 7.125C6.375 6.08947 7.21447 5.25 8.25 5.25H9.875C10.8415 5.25 11.625 6.0335 11.625 7M9 4.125V5.25M9 12.75V13.875M16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9Z"
        stroke-width="1.18293"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
